<template>
  <WebsitesList />
</template>
<script>
import WebsitesList from '@/components/Websites/WebsitesList.vue'

export default {
  name: 'WebsitesListView',
  components: {
    WebsitesList,
  }
}
</script>

<style scoped>
</style>
